import { render, staticRenderFns } from "./TheWalletFooter.vue?vue&type=template&id=19611fba"
import script from "./TheWalletFooter.vue?vue&type=script&lang=js"
export * from "./TheWalletFooter.vue?vue&type=script&lang=js"
import style0 from "./TheWalletFooter.vue?vue&type=style&index=0&id=19611fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports